<template>
	<!--
    	作者：luoyiming
    	时间：2019-10-25
    	描述：组件-用户来源
    -->
	<el-dialog title="用户来源" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
		:close-on-press-escape="false" width="900px">
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="userList" border style="width: 100%" highlight-current-row
					v-loading="loading">
					<el-table-column width="70" label="用户头像">
						<template slot-scope="scope">
							<img :src="scope.row.user.avatarUrl" width="30" height="30" />
						</template>
					</el-table-column>
					<el-table-column width="120" label="用户昵称">
						<template slot-scope="scope">
							<span>{{scope.row.user.nickName}}</span>
						</template>
					</el-table-column>
					<el-table-column width="200" align="center" label="上级用户信息">
						<template slot-scope="scope">
							<div v-if="scope.row.info && scope.row.info.id"
								style="display: flex;flex-direction: column;">
								<span class="gray9">ID:{{scope.row.info.id}}</span>
								<span>{{scope.row.info.name}}</span>
								<span>手机号：{{scope.row.info.mobile}}</span>
								<span>邀请码：{{scope.row.info.code}}</span>
							</div>
							<div v-else>
								<span>暂无上级</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="remarks" label="事件类型"></el-table-column>
					<el-table-column prop="createTime" width="140" label="添加时间"></el-table-column>
				</el-table>
			</div>

			<!--分页-->
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page="curPage" :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize"
					layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
			</div>
		</div>

		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible=false">取 消</el-button>
			<el-button size="small" type="primary" @click="dialogFormVisible">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import UserApi from '@/api/user.js';
	export default {
		data() {
			return {
				/*是否加载完成*/
				loading: true,
				/*当前是第几页*/
				curPage: 1,
				/*一页多少条*/
				pageSize: 10,
				/*一共多少条数据*/
				totalDataNumber: 0,
				//商品分类列表
				cateList: [],
				//商品列表
				userList: [],
				//类别列表
				status: [{
						id: 10,
						name: '上架'
					},
					{
						id: 20,
						name: '下架'
					}
				],
				multipleSelection: [],
				/*左边长度*/
				formLabelWidth: '120px',
				/*是否显示*/
				dialogVisible: false,
				/*传出去的参数*/
				params: null
			};
		},
		props: ['isUser', 'excludeIds', 'userId'],
		watch: {
			isUser: function(n, o) {
				if (n != o) {
					if (n) {
						this.dialogVisible = n;
						this.params = null;
						this.getData();
					} else {
						this.dialogVisible = n;
					}
				}
			}
		},
		created() {

		},
		methods: {
			/*选择第几页*/
			handleCurrentChange(val) {
				this.curPage = val;
				this.getData();
			},

			/*每页多少条*/
			handleSizeChange(val) {
				this.curPage = 1;
				this.pageSize = val;
				this.getData();
			},

			/*获取用户来源列表*/
			getData() {
				let self = this;
				let params = {};
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				params.user_id = self.userId;
				UserApi.userLog(params, true)
					.then(res => {
						if (res.code == 1) {
							self.loading = false;
							self.userList = res.data.data;
							self.totalDataNumber = res.data.total;
						}
					})
					.catch(error => {});
			},
			/*关闭弹窗*/
			dialogFormVisible() {
				this.$emit('closeDialog', {
					openDialog: false,
					params: this.params
				});
			}
		}
	};
</script>

<style>
	.no-list .el-checkbox {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/views/user/user/dialog/user.vue